import React from "react";
import { useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import CloseIcon from "@mui/icons-material/Close";
import { fDummyFunction, GridDataColumn } from "./Action";

import Modal from "@mui/material/Modal";
import GCTitleSticky from "./GCTitleSticky";
import { CmpTypographyField } from "../ToolBox/ToolBox";

const GCDiscountPercentage = ({
  fCloseDiscountPercentageModal = () => { },
  xGrossAmount = "",
  xLDiscAmount = "",
  xTDiscAmount = "",
  xTDiscPer = "",
  fonChangeInputDiscountModal,
  fOnChangeTDiscAmtModal,
  GetApplyTDiscount,
  xErrorMsg_DiscPerc = "",
  xErrorMsg_TDiscAmt = "",
  xRdx_DocStatus = false,
  xTitle = "Discount Percentage",
  sDiscountPercentageModal = false,
  isDiscounPercField=false, 
  onFocus=()=>{},
  onBlur=()=>{},
}) => {
  let xMdColTitle = 5;
  let xMdCoInput = 7;
  let xSmColTitle = 7;
  let xSmCoInput = 5;

  useEffect(() => {
    document?.getElementById("GCTransDiscount")?.focus();
  }, []);
  return (
    <Modal
      open={sDiscountPercentageModal}
      onClose={fCloseDiscountPercentageModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ overflow: "auto" }}
        className="model-GCTransDiscount-small-box"
      >
        <GCTitleSticky
          title={xTitle}
          onClose={fCloseDiscountPercentageModal}
        />

        <div className="px-2 py-5">
          <Grid container spacing={1} columns={{ xs: 12, sm: 12, md: 12 }}>
            <Grid
              item
              xs={xSmColTitle}
              sm={xSmColTitle}
              md={xMdColTitle}
              className="gnr-item-search-label"
            >

              <CmpTypographyField
                xcomponent={"span"}
                xText={"Gross Amount"}
              />
            </Grid>
            <Grid
              item
              xs={xSmCoInput}
              sm={xSmCoInput}
              md={xMdCoInput}
              className="gnr-item-search-label"
            >
              <input
                autoComplete="off"
                className="form-control form-control-sm"
                type="text"
                name="vA_GrossAmt"
                value={xGrossAmount}
                readOnly
              />
            </Grid>
            <Grid
              item
              xs={xSmColTitle}
              sm={xSmColTitle}
              md={xMdColTitle}
              className="gnr-item-search-label"
            >

              <CmpTypographyField
                xcomponent={"span"}
                xText={"L.Discount Amount"}
              />
            </Grid>
            <Grid
              item
              xs={xSmCoInput}
              sm={xSmCoInput}
              md={xMdCoInput}
              className="gnr-item-search-label"
            >
              <input
                autoComplete="off"
                className="form-control form-control-sm"
                type="text"
                name="A_LDiscAmt"
                value={xLDiscAmount}
                readOnly
              />
            </Grid>
            <Grid
              item
              xs={xSmColTitle}
              sm={xSmColTitle}
              md={xMdColTitle}
              className="gnr-item-search-label"
            >
              <CmpTypographyField
                xcomponent={"span"}
                xText={"T.Discount Percentage"}
              />

            </Grid>
            <Grid
              item
              xs={xSmCoInput}
              sm={xSmCoInput}
              md={xMdCoInput}
              className="gnr-item-search-label"
            >
              <input
                autoComplete="off"
                className="form-control form-control-sm"
                type="number"
                id="GCTransDiscount"
                name="xTDiscPer"
                readOnly={isDiscounPercField}
                value={xTDiscPer}
                onFocus={onFocus}
                onBlur={onBlur}
                onChange={
                  !!fonChangeInputDiscountModal
                    ? (e) => {
                      fonChangeInputDiscountModal(e);
                    }
                    : fDummyFunction
                }
              
              />
              <span
                className={
                  xErrorMsg_DiscPerc == "" ? "hide-error" : "show-error"
                }
              >
                {xErrorMsg_DiscPerc}
              </span>
            </Grid>
            <Grid
              item
              xs={xSmColTitle}
              sm={xSmColTitle}
              md={xMdColTitle}
              className="gnr-item-search-label"
            >
              <CmpTypographyField
                xcomponent={"span"}
                xText={"T.Discount Amount"}
              />

            </Grid>
            <Grid
              item
              xs={xSmCoInput}
              sm={xSmCoInput}
              md={xMdCoInput}
              className="gnr-item-search-label"
            >
              <input
                autoComplete="off"
                className="form-control form-control-sm"
                type="number"
                name="xTDiscAmount"
                value={xTDiscAmount}
                onFocus={onFocus}
                onBlur={onBlur}
                onChange={
                  !!fOnChangeTDiscAmtModal
                    ? (e) => {
                      fOnChangeTDiscAmtModal(e);
                    }
                    : fDummyFunction
                }
              />
              <span
                className={
                  xErrorMsg_TDiscAmt == "" ? "hide-error" : "show-error"
                }
              >
                {xErrorMsg_TDiscAmt}
              </span>
            </Grid>
          </Grid>
        </div>

        <Grid
          container
          spacing={1}
          columns={{ xs: 4, sm: 4, md: 12 }}
          className="text-center pt-2"
        >
          <Grid item xs={12} className="gnr-item-search-label">
            <Grid container spacing={1} columns={{ xs: 12, sm: 12, md: 12 }}>
              <Grid item xs={6} className="gnr-item-search-label">
                <button
                  className={
                    xRdx_DocStatus
                      ? "btn btn-secondary search-btn"
                      : "btn btn-primary  search-btn"
                  }
                  onClick={
                    !!GetApplyTDiscount ? GetApplyTDiscount : fDummyFunction
                  }
                  disabled={xRdx_DocStatus}
                >
                  Apply
                </button>
              </Grid>
              <Grid item xs={6} className="gnr-item-search-label">
                <button
                  className="btn btn-primary  search-btn"
                  onClick={
                    !!fCloseDiscountPercentageModal
                      ? fCloseDiscountPercentageModal
                      : fDummyFunction
                  }
                >
                  Cancel
                </button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default GCDiscountPercentage;
